export const getYoutubeId = url => {
  const regex = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i
  const match = url.match(regex)
  return match && match[7].length === 11 ? match[7] : false
}

export const getYoutubeThumbnail = id => {
  return `https://img.youtube.com/vi/${id}/0.jpg`
}
